import { getAsync } from "../httpServiceIntelafApi";

const URI = '/Klaviyo';

export const postSubscriptionLetter = (email) => {
    return getAsync(`${URI}?emailSubscribe=${email}`, {}).then((response) => {
        return response;
    });
};